// 全局API请求接口的地址
// 可以根据环境变量或者直接设置
const BaseApi = 'https://wjdw.ccswgfg.com/api/' // 请根据实际情况设置API基础地址

export {
	BaseApi
}